import {asyncStorage} from '../../config/constants';
import {tokenExpiresIn} from './OpenTokUtils';

const prefix = 'VIDEO_SESSION_TOKEN_';

export class VideoSessionService {
  static NAME = 'videoSessionService';

  constructor() {
    // overridable for testing
    this.asyncStorage = asyncStorage;
  }

  getToken(sessionId) {
    const sessionToken = this.asyncStorage.getItem(`${prefix}${sessionId}`);
    if (!sessionToken || tokenExpiresIn(sessionToken) <= 0) {
      return null;
    } else {
      return sessionToken;
    }
  }

  /**
   *
   * @param {String} sessionId
   * @param {String} sessionToken OpenTok not-JWT token
   * @return {boolean}
   */
  setToken(sessionId, sessionToken) {
    if (!sessionToken || tokenExpiresIn(sessionToken) <= 0) {
      return false;
    } else {
      this.asyncStorage.setItem(`${prefix}${sessionId}`, sessionToken);
    }
  }

  removeToken(sessionId) {
    this.asyncStorage.removeItem(`${prefix}${sessionId}`);
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/services/VideoSessionService.js